import { TransactionTypes, TransactionState } from '../types/transaction'

const initialState: TransactionState = {
  transactionsResult: [],
  loading: false,
}

export const transactionReducer = (
  state: TransactionState = initialState,
  action: any
) => {
  switch (action.type) {
    case TransactionTypes.GET_TRANSACTION_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case TransactionTypes.GET_TRANSACTION_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        transactionsResult: action.payload,
      }
    default:
      return state
  }
}
